'use strict';

var luxon = require('luxon');
var y = require('yup');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var y__namespace = /*#__PURE__*/_interopNamespaceCompat(y);

const name = 'expiry';
const EXPIRY_ERROR = 'expiry';
y__namespace.addMethod(y__namespace.StringSchema, name, function(options) {
    return this.test({
        name,
        message: {
            key: options?.error ?? EXPIRY_ERROR
        },
        test: (date)=>{
            if (!date) {
                return true;
            }
            /**
             * Check if input is in MM/YYYY format.
             */ const isCorrectFormat = ()=>{
                return Boolean(RegExp(/^\d{2}\/\d{4}$/).exec(date));
            };
            /**
             * Check if date is valid.
             */ const isValidDate = ()=>{
                // try/catch block to catch exception getting substrings
                try {
                    const expMonth = Number(date.slice(0, 2));
                    const expYear = Number(date.slice(-4));
                    /**
                     * Validate month.
                     */ if (!luxon.DateTime.fromObject({
                        month: expMonth
                    }).isValid) {
                        return false;
                    }
                    /**
                     * Validate that entered date is greater than current date.
                     */ return luxon.DateTime.now().year < expYear || luxon.DateTime.now().year === expYear && luxon.DateTime.now().month <= expMonth;
                } catch  {
                    return false;
                }
            };
            return isCorrectFormat() && isValidDate();
        }
    });
});

exports.EXPIRY_ERROR = EXPIRY_ERROR;
//# sourceMappingURL=expiry.js.map
